<div class="internal-server-error-page">
  <div class="error-container">
    <div class="error-content">
      <div class="error-image">
        <svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240" fill="none">
          <defs>
            <linearGradient id="serverBgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#FFE6E6;stop-opacity:0.6" />
              <stop offset="100%" style="stop-color:#FFB3B3;stop-opacity:0.3" />
            </linearGradient>
            <linearGradient id="screenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style="stop-color:#666;stop-opacity:0.9" />
              <stop offset="100%" style="stop-color:#333;stop-opacity:0.95" />
            </linearGradient>
          </defs>

          <circle cx="120" cy="120" r="110" fill="url(#serverBgGradient)"/>

          <!-- Monitor (PC) - slightly tilted "pifado" -->
          <g transform="translate(120, 95) rotate(-5)">
            <!-- Screen bezel -->
            <rect x="-55" y="-42" width="110" height="82" rx="8" fill="#555" stroke="#333" stroke-width="2"/>
            <!-- Screen (dark) -->
            <rect x="-48" y="-35" width="96" height="68" rx="4" fill="url(#screenGradient)"/>
            <!-- X / error on screen -->
            <line x1="-35" y1="-22" x2="35" y2="18" stroke="#FF6B6B" stroke-width="6" stroke-linecap="round"/>
            <line x1="35" y1="-22" x2="-35" y2="18" stroke="#FF6B6B" stroke-width="6" stroke-linecap="round"/>
            <!-- Stand -->
            <rect x="-12" y="42" width="24" height="18" rx="2" fill="#444" stroke="#333" stroke-width="1"/>
            <rect x="-25" y="58" width="50" height="8" rx="2" fill="#444" stroke="#333" stroke-width="1"/>
          </g>

          <!-- Small "smoke" or warning lines -->
          <g fill="none" stroke="#999" stroke-width="2" stroke-linecap="round" opacity="0.6">
            <path d="M 75 165 Q 85 158 95 165 Q 105 172 115 165"/>
            <path d="M 125 165 Q 135 158 145 165 Q 155 172 165 165"/>
          </g>

          <!-- Sad face / frown on "monitor" concept (optional small icon) -->
          <circle cx="120" cy="195" r="12" fill="#FF6B6B" opacity="0.9"/>
          <path d="M 115 198 Q 120 203 125 198" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/>
        </svg>
      </div>

      <div class="error-text">
        <h1 class="error-code">500</h1>
        <h2 class="error-title">{{ 'internalServerError.title' | translate }}</h2>
        <p class="error-message">{{ 'internalServerError.message' | translate }}</p>
        <p class="error-instruction">{{ 'internalServerError.instruction' | translate }}</p>

        <div class="error-actions">
          <app-button
            kind="ghost"
            (clicked)="goToHome()">
            {{ 'internalServerError.backToHome' | translate }}
          </app-button>
        </div>
      </div>
    </div>
  </div>
</div>
